<script>
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import { showAllTitles } from "../../stores/global.js";

  import Popper from "../Popper.svelte";

  export let width;
  export let height;
  export let style = "";

  import { gsap } from "gsap";
  import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

  let mounted = false;

  onMount(() => {
    gsap.registerPlugin(MorphSVGPlugin);
    mounted = true;
  });

  $: switchEye = function (currentPath) {
    if (!mounted) return;
    gsap.to(`#eye`, {
      morphSVG: {
        shape: currentPath,
      },
      duration: 0.5,
    });
  };

  const closedEyePath =
    "M 57.9375 34.792969 L 59.039062 33.761719 L 52.816406 27.125 C 55.652344 24.503906 57.242188 22.246094 57.394531 22.023438 L 56.15625 21.164062 C 56.066406 21.296875 46.953125 34.242188 32.410156 34.242188 C 17.878906 34.242188 8.507812 21.289062 8.414062 21.15625 L 7.183594 22.03125 C 7.347656 22.261719 9.097656 24.679688 12.183594 27.421875 L 6.242188 33.761719 L 7.34375 34.792969 L 13.332031 28.40625 C 15.582031 30.253906 18.40625 32.144531 21.738281 33.546875 L 17.789062 42.101562 L 19.160156 42.730469 L 23.199219 34.097656 C 25.835938 35.054688 28.800781 35.671875 32 35.734375 L 32 45.441406 L 33.28125 45.441406 L 33.28125 35.722656 C 36.480469 35.605469 39.402344 34.933594 42.003906 33.9375 L 46.09375 42.730469 L 47.476562 42.101562 L 43.453125 33.363281 C 46.742188 31.910156 49.507812 29.980469 51.683594 28.125 Z M 57.9375 34.792969 ";
  const openEyePath =
    "M60.8,31.4C60.3,30.7,47.6,13,32,13C16.3,13,3.7,30.7,3.2,31.4c-0.2,0.3-0.2,0.8,0,1.2C3.7,33.3,16.4,51,32,51  c15.5,0,28.3-17.7,28.8-18.4C61.1,32.2,61.1,31.8,60.8,31.4z M32,43c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S38.1,43,32,43z";

  $: currentPath = $showAllTitles == true ? openEyePath : closedEyePath;
  $: currentPath, switchEye(currentPath);

  $: currentTitle = `${$showAllTitles ? "Hide " : "Show "} titles`;

  let referenceElement;
  let visible = false;
</script>

<Popper {referenceElement} {visible} content={currentTitle}>
  <svg
    transition:fade
    bind:this={referenceElement}
    on:mouseover={() => {
      visible = true;
    }}
    on:focus={() => {
      visible = true;
    }}
    on:mouseleave={() => {
      visible = false;
    }}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    viewBox="0 0 64 64"
    xml:space="preserve"
    pointer-events="bounding-box"
    {width}
    {height}
    fill={"white"}
    style="stroke: {$showAllTitles
      ? 'transparent'
      : 'white'}; stroke-width: {$showAllTitles ? 0 : 2}px; {style}"
    on:click={() => {
      showAllTitles.set(!$showAllTitles);
    }}
  >
    <path id="eye" d={openEyePath} />
  </svg>
</Popper>

<style>
  svg {
    position: absolute;
    bottom: 30px;
    left: calc(2.5% + 25px);
    z-index: 10;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    svg {
      left: 4%;
      top: calc(4% + 25px);
    }
  }
</style>
